import React from "react";
import { Link } from "@/i18n/router";
import { Emblem } from "@/components/Emblem";

export function Logo({ light = true, className = "", showStars = true }) {
  const text = light ? "text-white" : "text-navy";
  return (
    <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="logo-link" aria-label="AstroLife home">
      <Emblem className="h-10 w-10 transition-transform duration-500 group-hover:rotate-[8deg]" showStars={showStars} />
      <span className={`font-heading text-lg font-extrabold tracking-tight ${text}`}>
        AstroLife<span className="text-astro-light align-super text-[10px]">™</span>
      </span>
    </Link>
  );
}
